<template>
  <div>
    <!-- <el-button v-if="this.applyStatus == 2 || this.applyStatus == '' || this.applyStatus == 0 || this.applyStatus == null" icon='el-icon-plus' size='mini' type="primary" @click="handleNewRows()">新建</el-button>
    <el-button v-if="this.applyStatus == 2 || this.applyStatus == '' || this.applyStatus == 0 || this.applyStatus == null" icon='el-icon-edit' size='mini' type='danger' @click="handleDelete()">删除</el-button> -->
    <el-button :loading="handleSaveLoading" style="float: right;margin-right: 5px;" @click="handleSave()" icon='el-icon-edit' size='mini' type="primary">保存</el-button>
    <span style="color: red;font-size: 12px;float:right;line-height: 30px;margin-right: 20px;">* 点击表格进行编辑</span>
    <h3>近三年经营状况</h3>
    <el-table-edit :model="dataList" :columns="['year','totalOutput','totalSales','totalProductivity','afterTaxProfit', 'imitatePartOutput', 'imitatePartTotalSales']" ref="editTable">
      <el-table :data="dataList" size="small" stripe style="width: 100%;" @selection-change="selectionChangeHandle" ref="table" :row-class-name="rowClassName" @row-dblclick="editAll">
        <el-table-column type="selection" fixed="left"></el-table-column>
        <el-table-column label="序号" header-align="center" align="center" width="50" prop="index">
          <template slot-scope="scope">
            {{ scope.$index + 1 }}
          </template>
        </el-table-column>
        <el-table-column prop="year" label="年份" align="center" header-align="center">
          <template slot-scope="scope">
            <span style="color: red;">*</span>
            <span>{{scope.row.year}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="totalOutput" label="总产量" align="center" header-align="center">
          <template slot-scope="scope">
            <el-input v-if="scope.row.show" v-model="scope.row.totalOutput" placeholder="总产量"></el-input>
            <span v-else>{{scope.row.totalOutput}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="totalSales" label="销售总收入（万元）(含税）" align="center" header-align="center">
          <template slot-scope="scope">
            <el-input v-if="scope.row.show" v-model="scope.row.totalSales" placeholder="销售总收入（万元）(含税）"></el-input>
            <span v-else>{{scope.row.totalSales}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="totalProductivity" label="全员劳动生产率（万元/人）" header-align="center" align="center">
          <template slot-scope="scope">
            <el-input type="email" v-if="scope.row.show" v-model="scope.row.totalProductivity" placeholder="全员劳动生产率（万元/人）"></el-input>
            <span v-else>{{scope.row.totalProductivity}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="afterTaxProfit" label="税后利润（万元）" header-align="center" align="center">
          <template slot-scope="scope">
            <el-input v-if="scope.row.show" v-model="scope.row.afterTaxProfit" placeholder="税后利润（万元）"></el-input>
            <span v-else>{{scope.row.afterTaxProfit}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="imitatePartOutput" label="拟引入零部件产量" header-align="center" align="center">
          <template slot-scope="scope">
            <el-input type="email" v-if="scope.row.show" v-model="scope.row.imitatePartOutput" placeholder="拟引入零部件产量"></el-input>
            <span v-else>{{scope.row.imitatePartOutput}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="imitatePartTotalSales" label="拟引入零部件销售总收入（万元）(含税）" header-align="center" align="center">
          <template slot-scope="scope">
            <el-input type="email" v-if="scope.row.show" v-model="scope.row.imitatePartTotalSales" placeholder="拟引入零部件销售总收入（万元）(含税）"></el-input>
            <span v-else>{{scope.row.imitatePartTotalSales}}</span>
          </template>
        </el-table-column>
      </el-table>
    </el-table-edit>
    <el-pagination
            @size-change="sizeChangeHandle"
            @current-change="currentChangeHandle"
            :current-page="pageIndex"
            :page-sizes="[10,15,20]"
            :page-size="pageSize"
            :total="totalPage"
            layout="total, sizes, prev, pager, next, jumper">
    </el-pagination>
  </div>
</template>

<script>
  import Vue from 'vue'
  import { saveSupplierBusinessYears, listSupplierBusinessYears, listInvitedForSupplier } from '@/controller/portal'
  export default {
    computed: {
      editTable() {
        return this.$refs.editTable
      }
    },
    data () {
      return {
        handleSaveLoading:false,
        //show:false,
        totalPage: 0,
        pageIndex:1,
        pageSize:15,
        dataForm: {
          key: ''
        },
        dataListLoading: false,
        editRowslist: [],
        dataList: [
          { year: new Date().getFullYear()-1, value: '1' },
          { year: new Date().getFullYear()-2, value: '2' },
          { year: new Date().getFullYear()-3, value: '3' },
        ],
        year: '',
        totalOutput: '',
        totalSales: '',
        totalProductivity: '',
        afterTaxProfit: '',
        imitatePartOutput: '',
        imitatePartTotalSales: '',
        venderInviteFid: '',
        // applyStatus: '',
        dataListSelections: []
      }
    },
    props: {
      applyStatus: String
    },
    mounted() {
      this.getList()
    },
    watch: {
      venderInviteFid() {
        this.getDataList()
      }
    },
    methods: {
      // 每页数
      sizeChangeHandle (val) {
        this.pageSize = val
        this.pageIndex = 1
        this.getDataList()
      },
      // 当前页
      currentChangeHandle (val) {
        this.pageIndex = val
        this.getDataList()
      },
      handleNewRows() {
        this.dataList.push({
          // edit: true,
        })
      },
      deletefront(row) {
        this.dataList.splice(row,1);
      },
      editAll() {
        //debugger
        let data = JSON.parse(JSON.stringify(this.dataList ? this.dataList : []));
        data.forEach((element) => {
          element["show"] = true;
        });
        this.dataList = data;
      },
      handleSave() {
        //校验必填
        for(var i=0; i<this.dataList.length;i++){
          if(!this.dataList[i].totalOutput){
            this.$message.error("企业经营状况的总产量不可为空")
            return
          }
          if(!this.dataList[i].totalSales){
            this.$message.error("企业经营状况的销售总收入不可为空")
            return
          }
        }
        //调用保存方法
        this.saveData(this.dataList)
      },
      saveData(list) {
       this.handleSaveLoading = true
        saveSupplierBusinessYears({
          'yearList' : list,
          'inviteId': this.venderInviteFid
        }).then(data => {
          if (data && data.code === '00') {
            this.$message({
              message: '操作成功',
              type: 'success',
            })
            this.getDataList()
            this.handleSaveLoading = false
          } else {
            this.handleSaveLoading = false
            this.$message.error(data.msg)
          }
        }).catch((e) => {
          this.handleSaveLoading = false
        })
      },
      getDataList() {
        listSupplierBusinessYears({
          'pageNo': this.pageIndex,
          'pageSize': this.pageSize,
          'inviteId' : this.venderInviteFid
        }).then(data => {
          if (data && data.code === '00') {
            if (data.body.records.length > 0){
              this.dataList = data.body.records
              this.totalPage = data.body.total
            }
          } else {
            // data.page.list[0].position == '法人'
            // data.page.list[1].position == '商务经理'
            this.totalPage = 0
          }
          this.dataListLoading = false
        })
      },
      // 多选
      selectionChangeHandle(val) {
        this.dataListSelections = val
      },
      rowClassName({
                     row,
                     rowIndex
                   }) {
        row.rowid = rowIndex + 1;
      },
      handleDelete(row) {
        var ids = row ? [row.rowid] : this.dataListSelections.map(item => {
          return item.rowid
        })
        var vendercontactIds = row ? [row.vendercontactId + ';' + row.position] : this.dataListSelections.map(item => {
          return item.vendercontactId + ';' + item.position
        })
        this.$confirm(`确定对${ids.join(',')}行进行[${row ? '删除' : '删除'}]操作?`, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          console.log(vendercontactIds)
          // this.$http({
          //   url: this.$http.adornUrl('/vendercontact/tvendercontact/delete'),
          //   method: 'post',
          //   data: this.$http.adornData(vendercontactIds, false)
          // }).then(({
          //   data
          // }) => {
          //   if (data && data.code === 0) {
          //     this.$message({
          //       message: '操作成功',
          //       type: 'success',
          //     })
          //     this.getDataList()
          //   } else {
          //     this.$message.error(data.msg)
          //   }
          // })
        })
      },
      getList() {
        listInvitedForSupplier().then(data => {
          this.venderInviteFid = data.body.records[0].id
        })
      },
    }
  }
</script>
